
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "RxDocumentos",
})

export default class RxDocumentos extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();

	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	historial = []
	file = []
	tratamiento_id = null
	descripcion = ''
	imageBase64: string | null = null;
	image= '';
	imageBaseUrl = `${process.env.VUE_APP_URL_BASE}`
	mounted() {
		setTimeout(this.getDocumentos, 1500);
	}

	get tratamientos() {
		return this.consultorioStore.tratamientos;
	}
	get loading() {
		return this.consultorioStore.loading;
	}
	get documentos() {
		return this.consultorioStore.documentos;
	}

	async getDocumentos() {
		await http.get(`getDocumentos/${this.paciente_id}`).subscribe({
			next: (response: AxiosResponse) => {
				this.consultorioStore.documentos = response.data
				this.historial = response.data;
			},
		})
	}
	handleFileChange() {

		//console.log(event.target.files);
		console.log(event);
		const file = event.target.files[0];
		this.image = file;
		
		// const files = event.target.files;
		// console.log(files);

		// if (files && files.length > 0) {
		// 	const reader = new FileReader();
		// 	console.log(reader)
		// 	reader.onload = () => {
		// 		this.imageBase64 = reader.result as string;
		// 		console.log(this.imageBase64)
		// 	};
		// 	reader.readAsDataURL(files[0]);
		// }
	}
	uploadImage() {
		if (this.image == '') {
			alert('Por favor selecciona una imagen.');
			return;
		}

		const data = {
			image: this.image,
			paciente_id: this.paciente_id,
			cita_id: 1,
			descripcion: this.descripcion
		}
		const formData = new FormData();
		formData.append('image', this.image);
		formData.append('paciente_id', this.paciente_id);
		formData.append('cita_id', '1');
		formData.append('descripcion', this.descripcion);

		this.consultorioService.adjuntarDocumento(formData);
		this.getDocumentos();
	}




}

